import { useMemo } from 'react';
import {
  GeometricAlgorithmType,
  geometricAlgorithmTypes,
} from '../domain/geometry/algorithm-types';

export const useGeometricAlgorithms = (): GeometricAlgorithmType[] =>
  useMemo(() => geometricAlgorithmTypes, []);
